import React from 'react'
import PropTypes from 'prop-types'
import { shuffle } from 'lodash'
import { connect } from 'react-redux'
import { me } from '../initial_state'
import PageTitle from '../features/ui/util/page_title'
import DefaultLayout from '../layouts/default_layout'
import GroupsCollection from '../features/groups_collection'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import {
  LinkFooter,
  GabAdTopPanel,
  GabAdBottomPanel,
} from '../features/ui/util/async_components'
import { BREAKPOINT_EXTRA_SMALL, SUGGESTION_TYPE_GROUPS } from '../constants'
import RandomSidebarPanels from '../components/sidebar/random_sidebar_panels'
import GroupsScrollableCollection from '../components/groups_scrollable_collection'
import SidebarPanelGroup from '../components/sidebar_panel_group'
import GroupsPanel from '../components/panel/groups_panel'
import ShortcutsPanel from '../components/panel/shortcuts_panel'
import ShortcutsAvatarList from '../components/shortcuts_avatar_list'

class GroupsPage extends React.PureComponent {

  render() {
    const { activeTab, children, isXS } = this.props

    const dontShowChildren = (activeTab === 'timeline' && !me)

    const tabs = [
      {
        title: 'Timeline',
        to: '/groups',
      },
      !!me && {
        title: 'My Groups',
        to: '/groups/browse/member',
      },
      !!me && {
        title: 'Admin',
        to: '/groups/browse/admin',
      },
      {
        title: 'Featured Groups',
        to: '/groups/browse/featured',
      },
      {
        title: 'Categories',
        to: '/groups/browse/categories',
      },
      !!me && {
        title: 'Discover',
        to: `/suggestions?view=${SUGGESTION_TYPE_GROUPS}`,
      },
    ].filter(Boolean)

    const actions = isXS ? [
      !!me && {
        attrTitle: 'Create new group',
        icon: 'add',
        to: '/groups/create',
      },
      {
        attrTitle: 'Search groups',
        icon: 'search',
        to: '/search/groups',
      },
    ].filter(Boolean) : undefined

    const title = 'Groups'

    const items = RandomSidebarPanels()
    const sidebarLayout = [
      <WrappedBundle key='groups-page-ad-panel' component={GabAdTopPanel} componentParams={{ pageKey: 'groups.sidebar', position: 1 }} />,
      ...shuffle(items),
      LinkFooter,
      <WrappedBundle key='groups-page-ad-panel-bottom' component={GabAdBottomPanel} componentParams={{ pageKey: 'groups.sidebar', position: 1 }} />
    ]

    const sidebarChildren = [
      <ShortcutsPanel type='group' noPanel />,
      <GroupsPanel groupType='member' max={20} noPanel padded />,
    ]

    return (
      <DefaultLayout
        title={title}
        button={!!me ? {
          title: 'Create new group',
          icon: 'add',
          to: '/groups/create',
        } : undefined}
        search={{
          placeholder: 'Search groups',
          to: '/search/groups',
        }}
        actions={actions}
        tabs={tabs}
        page='groups'
        layout={sidebarLayout}
        sidebarChildren={<SidebarPanelGroup layout={sidebarChildren} />}
      >
        <PageTitle path={title} />
        
        {
          activeTab === 'timeline' && !!me && isXS && 
          <div className={[_s.d, _s.mb15].join(' ')}>
            <GroupsScrollableCollection groupType='member' />
            <ShortcutsAvatarList type='group' />
          </div>
        }

        {
          !dontShowChildren && children
        }

        {
          dontShowChildren &&
          <GroupsCollection activeTab='featured' />
        }
      </DefaultLayout>
    )
  }

}

const mapStateToProps = (state) => ({
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

GroupsPage.propTypes = {
  activeTab: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default connect(mapStateToProps)(GroupsPage)
